import { Pipe, PipeTransform } from '@angular/core';
import { Filter, MultiSelectFilter } from '@models/filter-types';
import { isMultiSelectFilter } from '@shared/helpers/functions/helpers';

@Pipe({
    name: 'isMultiselectFilter',
    standalone: false,
})
export class IsMultiselectFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is MultiSelectFilter<unknown> {
        return isMultiSelectFilter(value);
    }
}
